import { render, staticRenderFns } from "./TariffConfirmation.vue?vue&type=template&id=487c9c4c&scoped=true&"
import script from "./TariffConfirmation.vue?vue&type=script&lang=ts&"
export * from "./TariffConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./TariffConfirmation.vue?vue&type=style&index=0&id=487c9c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c9c4c",
  null
  
)

export default component.exports